var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksArrowBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 85,
    viewBox: "0 0 523 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.5 0L517.5 76C517.5 78.2091 515.709 80 513.5 80L9 80C6.79086 80 5 78.2091 5 76L5.00001 -4.48042e-05",
    stroke: "url(#paint0_linear_330_1684)",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M517.5 0L517.5 76C517.5 78.2091 515.709 80 513.5 80L9 80C6.79086 80 5 78.2091 5 76L5.00001 -4.48042e-05",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_1684",
    x1: 517.5,
    y1: 40,
    x2: 486.081,
    y2: 215.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksArrowBottom);
export default __webpack_public_path__ + "static/media/howItWorks_arrow_bottom.24728650160a6691da26c9e210040cc9.svg";
export { ForwardRef as ReactComponent };